<template>
  <div class="Gauge4Charts">
    <div class="bumber-style">
      <div v-for="(item, index) in dashboardList" :key="index">
        <div
          :style="{
            fontSize: `${$w_Ratio(2 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          {{ item.desc }}
        </div>
        <div
          :style="{
            fontSize: `${$w_Ratio(18 + getShowfontSizeBase(), $store)}px`,
            fontWeight: 'bolder',
            color: 'transparent',
            background: `linear-gradient(to bottom,  #ffffff 20%,  ${chartColor[index]}  100%)`,
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
          }"
        >
          <CountTo :startVal="0" :endVal="item.value" :decimals="0" :duration="2000"> </CountTo>
        </div>
      </div>
    </div>
    <div class="echarbut">
      <div class="echarts" :id="Configuration.id"></div>
      <img src="@/assets/img/gaugebut.png" alt="" />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios';
import { request } from '../../../../common/request';
import { CountTo } from 'vue3-count-to';
export default {
  name: 'Gauge4Charts',
  components: { CountTo },
  props: {
    // 当前 页面 所有 场景 数据
    ProjectInfo: Object,
    //选中 拖出 图表 数据
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      loading: true,
      dashboardList: [],
      fontStyle: {},
      chartColor: [],
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {},
  methods: {
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let saturation = 0;
      let maxBear = 0;

      let posSize = {
        width: 260,
        height: 260,
        left: 50,
        top: 0,
      };
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
        this.chartColor = chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        saturation = ParamData?.saturation;
        maxBear = ParamData?.maxBear;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
        this.fontStyle = fontStyle;
      }
      if (this.Configuration.propertyData.posSize.value) {
        posSize = this.Configuration.propertyData.posSize.value;
      }

      let xData = [];
      let yData = [];
      let xyData = [];
      let minData = [];
      let maxNum = 0;
      this.dashboardList = [];

      this.dashboardList = source.map(item => {
        return {
          desc: item.x,
          value: item.y,
        };
      });

      let data = {
        num: saturation,
        name: '饱和度',
      };

      let width = posSize.width;
      let height = posSize.height;
      let cx = width / 2;
      let cy = height / 2;

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        angleAxis: {
          show: false,
          max: (maxBear * 3) / 2, //这里将极坐标最大值转换成仪表盘的最大值，(360度除以240度)
          type: 'value',
          startAngle: 210, //极坐标初始角度，从第一象限算起，大约在7-8点钟角度之间
          splitLine: {
            show: false, //隐藏坐标
          },
        },
        barMaxWidth: 12, //圆环宽度
        radiusAxis: {
          //隐藏坐标
          show: false,
          type: 'category',
        },
        polar: {
          //设置圆环位置和大小
          center: ['50%', '50%'],
          radius: '100%',
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                //上层圆环，用于显示真实数据
                value: data.num,
                itemStyle: {
                  color: {
                    //图形渐变颜色方法，四个数字分别代表，右，下，左，上，offset表示0%到100%
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1, //从左到右 0-1
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#13d7ef', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#13d7ef', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                  shadowColor: 'rgba(255, 255, 255, 0.2)', //加白色阴影产生高亮效果
                  shadowBlur: 10,
                },
              },
            ],
            barGap: '-90%', //柱间距离,用来将上下两层圆环重合
            coordinateSystem: 'polar', //类型，极坐标
            roundCap: true, //顶端圆角
            z: 2, //圆环层级，和zindex相似
          },
          {
            //下层圆环，用于显示最大值
            type: 'bar',
            data: [
              {
                value: maxBear,
                itemStyle: {
                  color: '#265195',
                  shadowColor: 'rgba(0, 0, 0, 0.2)', //加白色阴影产生高亮效果
                  shadowBlur: 5,
                  shadowOffsetY: 2,
                },
              },
            ],
            barGap: '-100%', //柱间距离,用来将上下两层圆环重合
            coordinateSystem: 'polar', //类型，极坐标
            roundCap: true, //顶端圆角
            z: 1, //圆环层级，和zindex相似
          },
          {
            //仪表盘
            type: 'gauge',
            radius: '100%',
            startAngle: 210, //起始角度，同极坐标
            endAngle: -30, //终止角度，同极坐标
            max: maxBear,
            splitNumber: 5, //分割线个数（除原点外）
            axisLine: {
              // 坐标轴线
              show: false,
            },
            pointer: {
              show: false,
            },
            axisLabel: {
              // 坐标轴数字
              textStyle: {
                fontSize: this.$h_Ratio(10, this.$store),
                color: '#8c8c8c',
              },
            },
            axisTick: {
              // 坐标轴标记
              length: 10,
              lineStyle: {
                color: '#13d7ef',
              },
            },
            splitLine: {
              // 分隔线
              length: 5,
              lineStyle: {
                width: 2,
              },
            },
            title: {
              //标题，显示'馆藏量'
              textStyle: {
                color: fontStyle.xAxisColor,
                shadowColor: fontStyle.xAxisColor,
                fontSize: fontStyle.xAxisSize,
              },
              offsetCenter: ['0', '-35%'], //位置偏移
            },
            detail: {
              //仪表盘数值
              formatter: function (params) {
                // 计算百分比饱和度（当前值/最大值*100）
                var currentValue = data.num;
                var maxValue = maxBear; // maxBear是定义的最大值
                var percentage = ((currentValue / maxValue) * 100).toFixed(0); // 保留1位小数
                // 使用富文本数组形式，为两行文本分别应用不同样式
                return ['{percentage|' + percentage + '%}', '{name|' + data.name + '}'].join('\n');
              },
              offsetCenter: ['0', '5%'],
              rich: {
                //编辑富文本样式
                percentage: {
                  fontSize: this.$h_Ratio(42, this.$store),
                  fontWeight: 'bold',
                  color: '#fed752',
                  align: 'center',
                  padding: [0, 0, 2, 0],
                },
                name: {
                  fontSize: this.$h_Ratio(14, this.$store),
                  color: '#fff',
                  align: 'center',
                },
              },
            },
            data: [
              {
                value: data.num,
                name: '',
              },
            ],
          },
        ],
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除定时器
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        try {
          let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
          if (!ChartsData) {
            reject('Error ChartsData 不存在！');
            return;
          }
          let filter = function (data, filter_text) {
            let dataSet = {};
            try {
              eval(filter_text);
            } catch (e) {
              console.error('过滤器执行错误:', e);
            }
            return dataSet;
          };
          this.getApiDataRes()
            .then(res => {
              // 检查res是否有效
              if (!res) {
                resolve({ source: [], seriesList: [] });
                return;
              }
              // query数据
              if (ChartsData.apiData && ChartsData.apiData.apiResponseQuery) {
                let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
                if (arryQuery.length >= 1) {
                  try {
                    arryQuery.forEach(item => {
                      if (res && typeof res === 'object') {
                        res = res[item];
                      } else {
                        res = undefined;
                      }
                    });
                  } catch (e) {
                    console.error('数据查询错误:', e);
                    res = undefined;
                  }
                }
              }
              // 判断是否使用过滤器
              if (
                ChartsData.apiData &&
                ChartsData.apiData.isUseFilter &&
                ChartsData.apiData.apiFilter &&
                res
              ) {
                try {
                  res = filter(res, ChartsData.apiData.apiFilter);
                } catch (e) {
                  console.error('过滤器应用错误:', e);
                  res = { source: [], seriesList: [] };
                }
              }
              console.log('getApiDataResByFilterAndResponseQuery');
              // 确保返回的数据结构完整
              let data = this.$_.cloneDeep(res || { source: [], seriesList: [] });
              resolve(data);
            })
            .catch(error => {
              console.error('API请求错误:', error);
              resolve({ source: [], seriesList: [] }); // 错误时返回默认空数据
            });
        } catch (error) {
          console.error('getApiDataResByFilterAndResponseQuery方法错误:', error);
          resolve({ source: [], seriesList: [] }); // 捕获所有错误，返回默认空数据
        }
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = echarts.init(mychartDom, 'dark');
      console.log('ECharts Options:', this.echartsOptions);
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '数值仪表盘',
    componentName: 'Gauge4Charts',
    componentOverViewImg: './img/charts/GaugeCharts/Gauge4Charts.png',
    id: '',
    style: {
      width: 565,
      height: 323,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: ['#e6ebf8', '#100c2a', '#ffc300', '#00e473', '#009DFF'],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['数据'],
            source: [
              {
                s: '数据',
                x: '今日',
                y: 1700,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 260,
          height: 260,
          left: 50,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          top: '17%',
          bottom: '57%',
          left: '50%',
          right: '',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Gauge4Charts {
  color: white;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .echarbut {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
  }

  .echarts {
    width: 100%;
    height: 100%;
  }

  .echarbut img {
    position: absolute;
    bottom: 10%;
  }

  .bumber-style div {
    margin: 8px 0;
  }
}
@media screen and (min-width: 2500px) {
  .bumber-style div div:nth-child(1) {
    font-size: 26.26px !important;
  }
  .bumber-style div div:nth-child(2) {
    font-size: 46.54px !important;
  }
}
</style>
